export default __webpack_public_path__ + "static/media/FEMUR_SAGITAL_RIGHT.845f8f97.jpg";